// Hint — tanda "?" kecil berisi keterangan pendek (K200 butir 7, 27 Sep 2026).
//
// Keterangan yang lebih dari satu kalimat dipindah ke sini (maksimal 2 kalimat). Dibuka dengan klik di desktop dan
// ketuk di HP — bukan hover, karena hover tidak ada di layar sentuh. PENGECUALIAN vonis: peringatan soal uang, data
// hilang, atau tindakan yang tidak bisa dibatalkan TETAP tampil terbuka, jangan dimasukkan ke Hint.
//
// Pakai:  <label>Tanggal janji kirim <Hint>Dihitung dari DP masuk + SLA produksi region. Minggu dan libur tidak
//         dihitung.</Hint></label>
import React from "react";
import { CircleHelp } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

export default function Hint({ children, label = "Keterangan", className = "", side = "top" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={label}
          data-testid="hint"
          className={`inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full align-middle text-muted-foreground hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}
          onClick={(e) => e.stopPropagation()}
        >
          <CircleHelp className="h-4 w-4" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent side={side} className="w-64 p-3 text-sm leading-snug" data-testid="hint-isi">
        {children}
      </PopoverContent>
    </Popover>
  );
}
